import React from "react";
import PropTypes from "prop-types";
import PrimaryLink from "../../../elements/primary-link";
import classNames from "classnames";

const MobilePriceBanner = ({ tag, value, cta, showInSameFontSize, showFootnote, footnoteSymbol, showYourPrice, italianDiscalimerPrice }) => {
  return (
    <div className="mobile-price-banner">
      <div className="grid">
        <div className="price">
          {showYourPrice?.value && (
            <>
              <div className="tag">{tag}</div>
              <div className={classNames("value", { "same-size": showInSameFontSize?.value })}>
                {value}
                {italianDiscalimerPrice && (
                  <>
                    <br /> {italianDiscalimerPrice}
                  </>
                )}
                {showFootnote?.value && <span className="footnote">{footnoteSymbol?.value}</span>}
              </div>
            </>
          )}
          {cta && (
            <PrimaryLink
              {...{
                ...cta,
                colorScheme: cta.colorScheme || "green"
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

MobilePriceBanner.propTypes = {
  tag: PropTypes.string,
  value: PropTypes.string,
  cta: PropTypes.shape({
    colorScheme: PropTypes.object
  })
};

export default MobilePriceBanner;
